<template>
  <div class="limited-time-award-list">
    <div class="award-list-wrap" ref="awardListWrap">
      <div ref="awardList" class="award-list">
        <div
          class="award-content"
          v-for="(award, index) in awardList"
          :key="index"
        >
          <img class="award-icon" :src="award.icon" alt="" />
          <span class="award-num">{{ award.num || '' }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
import IScroll from '@utiles/iscroll.js';
export default {
  name: 'limitedTimeAwardList',
  props: ['awardList'],
  data() {
    return {
      scroll: null
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.initScroll();
    });
  },
  methods: {
    initScroll() {
      if (!this.scroll) {
        let width = 83 * this.awardList.length;
        this.$refs.awardList.style.width = width + 'px';
        this.scroll = new IScroll(this.$refs.awardListWrap, {
          mouseWheel: true,
          scrollX: true,
          tap: true
        });
      } else {
        this.scroll.refresh();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialStore/officialStore.scss';
.limited-time-award-list {
  .award-list-wrap {
    width: 100%;
    white-space: nowrap;
    overflow: -moz-scrollbars-none;
    overflow-x: scroll;
    overflow-y: auto;
    touch-action: pan-y;
    -ms-overflow-style: none;
    scrollbar-width: none;
    &::-webkit-scrollbar {
      display: none;
    }

    .award-list {
      display: -webkit-box;
      flex-wrap: nowrap;

      .award-content {
        position: relative;
        width: 73px;
        height: 74px;
        background-size: cover;
        background-repeat: no-repeat;
        @psetbg ('prop-item-bg.png', false, false);
        display: flex;
        justify-self: center;
        align-items: center;

        .award-icon {
          width: 100%;
          height: 100%;
        }

        .award-num {
          position: absolute;
          right: 5px;
          top: 5px;
          font-size: 13px;
          color: var(--product-item-prop-num);
        }
      }
    }

    .award-content + .award-content {
      margin-left: 6px;
    }
  }
}
</style>
